import React, {useEffect, useState} from 'react'
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import config from "../../../config.js";
import {trans} from "../../utils";

const Index = (ComponentToRenderData) => {
    let history = useHistory();
    const params = useParams();
    const SystemUrl = ComponentToRenderData.SystemUrl;
    const token = localStorage.getItem('token')
    const [data, setData ] = useState([]);
    const search = window.location.search;
    let URLParams = new URLSearchParams(search);
    const routeChange = path => {
        history.push(path);
    }

    useEffect(() => {
        axios(config.SystemUrl + `Contract/${params.id}?include=supplier,currency,coverage_type,measuring_period,penalty_uom`, {
            headers: {
                "Accept": "application/json",
                "lang": "en",
                'Authorization' : "Bearer " + token
            }
        })
            .then(result => setData(result.data.data));
    }, [])


    return (
        <>
            <div className="d-flex flex-column flex-xl-row">
                <div className="flex-column flex-lg-row-auto w-100 w-xl-350px row">
                    <div className="col-md-4">
                        <div className="card mb-5">
                            <span  className="p-20 text-center badge-light-primary">
                                <h4> {trans(data.contract_ref)}</h4>
                            </span>
                            <span className="p-2 bg-light text-center">
                                <h4>{trans(data.contract_type)}</h4>
                            </span>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="tab-content" id="myTabContent">
                            <div className="tab-pane fade active show" id="kt_techincal_tab" role="tabpanel">
                                <div className="card">
                                    <div className="card-header card-header-stretch">
                                        <div className="card-title d-flex align-items-center">
                                            <h4 className="mb-1">{trans('Contract Details')}</h4>
                                        </div>
                                    </div>
                                    <div className="card-body pt-0">
                                        <div className="fs-6">
                                            { data.supplier && data.supplier.hasOwnProperty("name") &&
                                            <>
                                                <div className="fw-bolder mt-3">{trans('Supplier')}</div>
                                                <div className="text-gray-600">{trans(data.supplier.name)}</div>
                                            </>
                                            }
                                            { data.contract_value &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Contract value')}</div>
                                                <div className="text-gray-600">{trans(data.contract_value)}</div>
                                            </>
                                            }
                                            { data.currency && data.currency.hasOwnProperty("title") &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Currency')}</div>
                                                <div className="text-gray-600">{trans(data.currency.title)}</div>
                                            </>
                                            }

                                            { data.coverage_type && data.coverage_type.hasOwnProperty("title") &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Coverage type')}</div>
                                                <div className="text-gray-600">{trans(data.coverage_type.title)}</div>
                                            </>
                                            }
                                            { data.measuring_period && data.measuring_period.hasOwnProperty("title") &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Measuring period')}</div>
                                                <div className="text-gray-600">{trans(data.measuring_period.title)}</div>
                                            </>
                                            }
                                            { data.penalty_uom && data.penalty_uom.hasOwnProperty("title") &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Penalty UOM')}</div>
                                                <div className="text-gray-600">{trans(data.penalty_uom.title)}</div>
                                            </>
                                            }
                                            { data.penalty_rate &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Penalty rate')}</div>
                                                <div className="text-gray-600">{trans(data.penalty_rate)}</div>
                                            </>
                                            }
                                            { data.response_time &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Response time')}</div>
                                                <div className="text-gray-600">{trans(data.response_time)}</div>
                                            </>
                                            }
                                            { data.repair_time &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Repair time')}</div>
                                                <div className="text-gray-600">{trans(data.repair_time)}</div>
                                            </>
                                            }
                                            { data.uptime &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Uptime')}</div>
                                                <div className="text-gray-600">{trans(data.uptime)}</div>
                                            </>
                                            }
                                            { data.from_date &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Date from')}</div>
                                                <div className="text-gray-600">{trans(data.from_date)}</div>
                                            </>
                                            }
                                            { data.to_date &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Date to')}</div>
                                                <div className="text-gray-600">{trans(data.to_date)}</div>
                                            </>
                                            }
                                            { data.import_grace_period &&
                                            <>
                                                <div className="separator mb-2 mt-2"></div>
                                                <div className="fw-bolder mt-3">{trans('Import grace period')}</div>
                                                <div className="text-gray-600">{trans(data.import_grace_period)}</div>
                                            </>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}
export default Index;
